import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "firebase/auth";
import { PropTypes } from "prop-types";
import { Row, Col, Layout, Typography } from "antd";
import BranchListItem from "./BranchListItem";
import DashboardHeader from "../../../components/header/index";
import BranchesListWrapper from "./BranchesList.style";
import { useIntl } from "react-intl";
import { useUserBranches } from "../../../hooks/accessControl";

const { Title } = Typography;

const BranchSelector = (props) => {
  const { profile } = useSelector((state) => state.user);
  const [branches, setBranches] = useState([]);
  const intl = useIntl();

  const userBranches = useUserBranches();

  useEffect(() => {
    let branchesIds = [];
    if (profile.roles) {
      profile.roles.forEach((role) => {
        if (role.branch_id) {
          branchesIds.push(role.branch_id);
        }
      });
    }
    let arr = [];

    profile.roles.forEach((role, i) => {
      const item = userBranches.filter(
        (branch) => branch.id === role.branch_id
      )[0];
      if (item) {
        arr.push(item);
      }
    });
    setBranches(arr);
  }, [profile.roles, userBranches]);

  const renderBranches = () => {
    return branches.map((branch, i) => {
      return (
        <Col
          key={branch.id}
          xs={24}
          sm={24}
          md={8}
          lg={6}
          xl={6}
          style={{ height: "auto", padding: "0 7px 15px" }}
        >
          <BranchListItem branch={branch} />
        </Col>
      );
    });
  };

  return (
    <Layout style={{ height: "100vh" }}>
      <DashboardHeader />
      <Layout style={{ padding: "40px" }}>
        <BranchesListWrapper>
          <Title level={1} style={{ paddingBottom: "40px" }}>
            {intl.formatMessage({
              id: "app.users.chooseBranch",
            })}
          </Title>
          <Row style={{ width: "100%" }}>{renderBranches()}</Row>
        </BranchesListWrapper>
      </Layout>
    </Layout>
  );
};

BranchSelector.propTypes = {
  branches: PropTypes.array,
};

export default BranchSelector;
